import styled from 'styled-components';

export const FilterGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: red;
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.grey3};
  border-radius: 16px;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  h4 {
    color: ${({ theme }) => theme.colors.grey5};
    margin-top: 0;
    font-size: 14px;
  }
`;
